import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import Loader from '../../Loader'
import ViewImage from '../../ViewImage'

function CategoryView({ category }) {
  const data = [
    { label: 'Category Name', data: category[0].categoryName },
    { label: 'Description', data: category[0].description },
    { label: 'Image', data: <ViewImage image={category[0].image} /> },
  ]
  return (
    <Grid container>
      {category ? (
        <Grid item lg={12} container spacing={3}>
          {data.map((item, index) => (
            <Grid item lg={4} key={index}>
              <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{item.label}</Typography>
                {item.label === 'Image' ? (
                  item.data
                ) : (
                  <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
                )}
              </div>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Loader />
      )}
    </Grid>
  )
}

export default CategoryView
